import React from "react";
import { Sidebar } from "../Sidebar";

const ErrorState = ({ error, embedded = false }) => {
  const content = (
    <div className="flex justify-center items-center h-full">
      <div className="text-center">
        <div className="text-red-500 text-6xl mb-4">⚠️</div>
        <div className="text-xl text-red-600">{error}</div>
      </div>
    </div>
  );

  if (embedded) {
    return <div className="p-4">{content}</div>;
  }

  return (
    <div className="flex h-screen">
      <Sidebar />
      <div className="flex-1 p-4 overflow-auto">{content}</div>
    </div>
  );
};

export default ErrorState;
